// @flow
import React, { Component } from 'react';
import MasonryPerfTiming from 'app/common/react/components/Masonry/MasonryPerfTiming';
import ProductGroupCardContainer from 'app/common/react/components/profile/ProductGroupCard/ProductGroupCardContainer';
import { GRID_ITEM_SPACING_DESKTOP } from 'app/common/lib/react/gridUtils';

type Props = {|
  isOwnProfile: boolean,
  productGroups: Array<Object>,
  scrollContainer?: () => HTMLElement,
  username: string,
|};

const CONTAINER_WIDTH = 310;
const LAYOUT_TYPE = 'wide';

export default class ProductGroupsList extends Component<Props> {
  renderProductGroup = (props: { data: any, itemIdx: number }) => {
    const productGroup = props.data;
    const { isOwnProfile, username } = this.props;

    if (!productGroup) {
      return null;
    }

    return (
      <ProductGroupCardContainer
        productGroup={productGroup}
        isOwnProfile={isOwnProfile}
        username={username}
        layout={LAYOUT_TYPE}
      />
    );
  };

  render() {
    const { productGroups, scrollContainer } = this.props;
    return (
      <MasonryPerfTiming
        columnWidth={CONTAINER_WIDTH}
        comp={this.renderProductGroup}
        gutterWidth={GRID_ITEM_SPACING_DESKTOP}
        items={productGroups}
        loadItems={() => {}}
        scrollContainer={scrollContainer}
        viewParameterType={PCONST.thrift.ViewParameterType.USER_STOREFRONT}
        isFetching={false}
        isGridCentered
        minCols={1}
        useMasonry9={false}
      />
    );
  }
}
